export default __webpack_public_path__ + "static/media/an-awesome-wave.80e5deec.jpg";